module.exports = __webpack_public_path__ + "img/gsb49.ca9b7b78.png";